import { render } from "./dlt-basic.vue?vue&type=template&id=8a478f92&scoped=true"
import script from "./dlt-basic.vue?vue&type=script&lang=js"
export * from "./dlt-basic.vue?vue&type=script&lang=js"

import "./dlt-basic.vue?vue&type=style&index=0&id=8a478f92&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a478f92"]])

export default __exports__